import React from 'react';
import { Box } from '@mui/material';

import { useIsClientInMobileMode } from '../../hooks';
import { LeftSidebarControlToolbar } from '../../toolbars/top/LeftSidebarControlToolbar';
import { FloatingOverSceneColumn } from './common/FloatingOverSceneColumn';
import { ComponentLabelFloatingBox } from './ComponentLabelFloatingBox';
import { PerformanceStatisticsFloatingBox } from './PerformanceStatisticsFloatingBox';

interface Props {
  leftSidebarOpen: boolean;
  rightSidebarOpen: boolean;
}

export function LeftFloatingColumn({ leftSidebarOpen, rightSidebarOpen }: Props) {
  const mobile = useIsClientInMobileMode();

  return (
    <FloatingOverSceneColumn side="left">
      <ComponentLabelFloatingBox />

      {mobile && <Box sx={{ flexGrow: 1 }} />}

      <LeftSidebarControlToolbar open={leftSidebarOpen} otherSidebarOpen={rightSidebarOpen} onMobile={mobile} />

      {!mobile && (
        <>
          <Box sx={{ flexGrow: 1 }} />
          <PerformanceStatisticsFloatingBox />
        </>
      )}
    </FloatingOverSceneColumn>
  );
}
